export default class StorageHandler{
    static ToBase64(value){
        value = btoa(value);
        value = value.replace(/=+$/, '');
        return value;
    }

    static FromBase64(value){
        try {
            // Check if the string looks like valid base64
            if (!value || typeof value !== 'string') {
                return value;
            }
            
            // Basic validation for base64 format
            const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
            if (!base64Regex.test(value)) {
                console.warn('String does not appear to be valid Base64:', value);
                return value;
            }
            
            const decoded = atob(value);
            return decoded;
        } catch (error) {
            // If atob fails, return the original value (not Base64 encoded)
            console.warn('Failed to decode Base64 string:', value, error.message);
            return value;
        }
    }

    static encryptJson(json){
        var base64 = JSON.stringify(json);
        base64 = base64.replace(/[\u00A0-\u9999<>]/gim, function(i) {
            return '&#'+i.charCodeAt(0)+';';
        });
        return this.ToBase64(base64);
    }

    static decryptJson(encrypted){
        var base64 = this.FromBase64(encrypted);
        base64 = base64.replace(/&#(\d+);/g, function(match, dec) {
            return String.fromCharCode(dec);
        });
        return JSON.parse(base64);
    }

    static InsertSessionStorage(name, value){
        if (!name || !value) {
            console.error(`InsertSessionStorage: Invalid value provided for key "${name}".`, value);
            return;
        }
        name = this.ToBase64(name);
        try {
            let serializedValue = this.encryptJson(value);
            sessionStorage.setItem(name, serializedValue);
        } catch (error) {
            console.error(`InsertSessionStorage: Failed to store data for key "${name}".`, error);
        }
    }

    static LoadSessionStorage(name){
        name = this.ToBase64(name);
        if (sessionStorage.getItem(name)) {
            try {
                let data = sessionStorage.getItem(name);
                data = this.decryptJson(data);
                return data;
            } catch (error) {
                sessionStorage.removeItem(name);
                return null;
            }
        } else {
            return null;
        }
    }

    static RemoveSessionStorage(name){
        name = this.ToBase64(name);
        sessionStorage.removeItem(name);
    }

    static InsertLocalStorage(name, value) {
        if (!name || !value || typeof value !== 'object') {
            console.error(`InsertLocalStorage: Invalid value provided for key "${name}".`, value);
            return;
        }
        name = this.ToBase64(name);
        try {
            value = {
                data: value,
                timestamp: Date.now(),
            };
            let serializedValue = JSON.stringify(value);
            serializedValue = this.encryptJson(serializedValue);
            localStorage.setItem(name, serializedValue);
        } catch (error) {
            console.error(`InsertLocalStorage: Failed to store data for key "${name}".`, error);
        }
    }

    static LoadLocalStorage(name, minutes) {
        name = this.ToBase64(name);
        if (localStorage.getItem(name)) {
            try {
                let data = localStorage.getItem(name);
                data = this.decryptJson(data);
                const parsedData = JSON.parse(data);
                const timeDelay = minutes * 60 * 1000;
                if (Date.now() - parsedData.timestamp < timeDelay) {
                    return parsedData.data;
                } else {
                    localStorage.removeItem(name);
                    return null;
                }
            } catch (error) {
                console.error(`LoadLocalStorage: Failed to load or parse data for key "${name}".`, error);
                localStorage.removeItem(name);
                return null;
            }
        } else {
            return null;
        }
    }

    static RemoveLocalStorage(name){
        name = this.ToBase64(name);
        localStorage.removeItem(name);
    }

    static RemoveLocalStorageAll(except = []){
        const keysToRemove = Object.keys(localStorage).filter(key => {
            // First check if the original key is in the exception list
            if (except.includes(key)) {
                return false;
            }
            
            // Try to decode and check if decoded key is in exception list
            try {
                const decodedKey = this.FromBase64(key);
                return !except.includes(decodedKey);
            } catch (error) {
                // If decoding fails, the key is not Base64 encoded
                // Keep it unless it's in the exception list (already checked above)
                return true;
            }
        });
        keysToRemove.forEach(key => localStorage.removeItem(key));
    }

    static RemoveSessionStorageAll(except = []) {
        const keysToRemove = Object.keys(sessionStorage).filter(key => {
            // First check if the original key is in the exception list
            if (except.includes(key)) {
                return false;
            }
            
            // Try to decode and check if decoded key is in exception list
            try {
                const decodedKey = this.FromBase64(key);
                return !except.includes(decodedKey);
            } catch (error) {
                // If decoding fails, the key is not Base64 encoded
                // Keep it unless it's in the exception list (already checked above)
                return true;
            }
        });
        keysToRemove.forEach(key => sessionStorage.removeItem(key));
    }
}